// const catalog = [
//   {
//     id: '11W14122103021',
//     desc: 'AGM Wolf-14 NL2 - Night Vision Monocular Gen 2+ "Green Phosphor" "Level 2"',
//     price: '$1,784.08',
//   },
//   {
//     id: '11W14122104021',
//     desc: 'AGM Wolf-14 NW2 - Night Vision Monocular Gen 2+ "White Phosphor Level 2"',
//     price: '$2,099.10',
//   },
//   {
//     id: '11P14122453111',
//     desc: 'AGM PVS-14 NL1 - Night Vision Monocular Gen 2+ Autogated "Green Phosphor" "Level 1"',
//     price: '$2,619.23',
//   },
//   {
//     id: '11P14123453111',
//     desc: 'AGM PVS-14 3AL1 - Night Vision Monocular Gen 3+ Auto-Gated "Green Phosphor" "Level 1"',
//     price: '$3,356.64',
//   },
//   {
//     id: '11P14123454111',
//     desc: 'AGM PVS-14 3AW1 - Night Vision Monocular Gen 3+ Auto-Gated "White Phosphor"  "Level 1"',
//     price: '$3,777.27',
//   },
//   {
//     id: '11P15123453111',
//     desc: 'AGM PVS14-51 3AL1 - Night Vision Monocular 51 degree FOV Gen 3+ Auto-Gated "Green Phosphor" "Level 1"',
//     price: '$3,461.41',
//   },
//   {
//     id: '11P15123454111',
//     desc: 'AGM PVS14-51 3AW1 - Night Vision Monocular 51 degree FOV Gen 3+ Auto-Gated "White Phosphor Level 1"',
//     price: '$3,883.74',
//   },
//   {
//     id: '11PO4122453111',
//     desc: 'AGM PVS14-OMEGA NL1 - Light Weight Night Vision Monocular 51 degree FOV Gen 2+ Autogated "Green Phospor"  "Level 1"',
//     price: '$3,148.43',
//   },
//   {
//     id: '11PO4123453111',
//     desc: 'AGM PVS14-OMEGA 3AL1 - Light Weight Night Vision Monocular 51 degree FOV Gen 3+ Auto-Gated "Green Phosphor" "Level 1"',
//     price: '$3,776.75',
//   },
//   {
//     id: '11PO4123454111',
//     desc: 'AGM PVS14-OMEGA 3AW1 - Light Weight Night Vision Monocular 51 degree FOV Gen 3+ Auto-Gated "White Phosphor Level 1"',
//     price: '$4,199.19',
//   },
//   {
//     id: '6103MHM1',
//     desc: 'MICH Helmet Mount Assembly (PVS-7, PVS-14)',
//     price: '$250.53',
//   },
//   {
//     id: '61023XA1',
//     desc: 'AGM Afocal Magnifier Lens Assembly, 3X',
//     price: '$240.03',
//   },
//   {
//     id: '61025XA1',
//     desc: 'AGM Afocal Magnifier Lens Assembly, 5X',
//     price: '$418.95',
//   },
//   {
//     id: '6107WMP1',
//     desc: 'Weapon Mount for PVS-14',
//     price: '$82.74',
//   },
//   {
//     id: '6610HCS1',
//     desc: 'Hard Case for Storage/Transportation',
//     price: '$98.49',
//   },
//   {
//     id: '12WO7122103021',
//     desc: 'AGM Wolf-7 NL2 - Night Vision Goggle Gen 2+ "Green Phosphor" "Level 2"',
//     price: '$1,886.77',
//   },
//   {
//     id: '12WO7122104021',
//     desc: 'AGM Wolf-7 NW2 - Night Vision Goggle  Gen 2+ "White Phosphor Level 2"',
//     price: '$2,099.16',
//   },
//   {
//     id: '6103HM71',
//     desc: 'AGM Helmet Mount W7MP for MICH and PASGT Helmets',
//     price: '$261.66',
//   },
//   {
//     id: '6103HS71',
//     desc: 'AGM Helmet Mount W7S for Shroud',
//     price: '$271.95',
//   },
//   {
//     id: '12PV7122253011',
//     desc: 'AGM PVS-7 NL1 - Night Vision Goggle Gen 2+ "Green Phosphor" "Level 1"',
//     price: '$2,936.43',
//   },
//   {
//     id: '12PV7123253011',
//     desc: 'AGM PVS-7 3NL1 - Night Vision Goggle Gen 3 "Green Phosphor" "Level 1"',
//     price: '$3,986.60',
//   },
//   {
//     id: '14NV4122453111',
//     desc: 'AGM NVG-40 AL1 - Dual Tube Night Vision Goggle/Binocular Gen 2+ Autogated "Green Phosphor" "Level 1"',
//     price: '$4,512.27',
//   },
//   {
//     id: '14NV4123453111',
//     desc: 'AGM NVG-40 3AL1 - Dual Tube Night Vision Goggle/Binocular Gen 3+  "Green Phosphor" Auto-Gated "Level 1"',
//     price: '$6,296.70',
//   },
//   {
//     id: '14NV4123454111',
//     desc: 'AGM NVG-40 3AW1 - Dual Tube Night Vision Goggle/Binocular Gen 3+ Auto-Gated "White Phosphor" "Level 1"',
//     price: '$7,663.74',
//   },
//   {
//     id: '14NV5122453111',
//     desc: 'AGM NVG-50 AL1 - Dual Tube Night Vision Goggle/Binocular 51 degree FOV Gen 2+ Autogated "Green Phosphor" "Level 1"',
//     price: '$4,828.53',
//   },
//   {
//     id: '14NV5123453111',
//     desc: 'AGM NVG-50 3AL1 - Dual Tube Night Vision Goggle/Binocular 51 degree FOV Gen 3+ Auto-Gated "Level 1"',
//     price: '$6,823.74',
//   },
//   {
//     id: '14NV5123454111',
//     desc: 'AGM NVG-50 3AW1 - Dual Tube Night Vision Goggle/Binocular 51 degree FOV Gen 3+ Auto-Gated "White Phosphor Level 1"',
//     price: '$7,873.95',
//   },
//   {
//     id: '6104GK51',
//     desc: 'AGM Goggle Kit W G50',
//     price: '$261.66',
//   },
//   {
//     id: '6103HM51',
//     desc: 'AGM Helmet Mount G50MP for MICH and PASGT Helmets',
//     price: '$277.83',
//   },
//   {
//     id: '6103HS51',
//     desc: 'AGM Helmet Mount G50S for Shroud',
//     price: '$314.16',
//   },
//   {
//     id: '6108EBP1',
//     desc: 'AGM External Battery Pack Kit G50',
//     price: '$523.74',
//   },
//   {
//     id: '13FXB522103021',
//     desc: 'AGM FoxBat-5 NL2 - Night Vision Bi-Ocular 5x Gen 2+ "Green Phosphor" "Level 2" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$2,099.16',
//   },
//   {
//     id: '13FXB522104021',
//     desc: 'AGM FoxBat-5 NW2 - Night Vision Bi-Ocular 5x Gen 2+ "White Phosphor Level 2" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$2,309.16',
//   },
//   {
//     id: '13FXL622253011',
//     desc: 'AGM FoxBat-LE6 NL1 - Night Vision Bi-Ocular 5.6x Gen 2+ "Green Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$3,463.95',
//   },
//   {
//     id: '13FXL623253011',
//     desc: 'AGM FoxBat-LE6 3NL1 - Night Vision Bi-Ocular 5.6x Gen 3 "Green Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$4,723.95',
//   },
//   {
//     id: '13FXL623253111',
//     desc: 'AGM FoxBat-LE6 3NL1 - Night Vision Bi-Ocular 5.6x Gen 3 "White Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$5,375.00',
//   },
//   {
//     id: '13FXL722253011',
//     desc: 'AGM FoxBat-LE7 NL1 - Night Vision Bi-Ocular 7.4x Gen 2+ "Green Phosphor"  "Level 1" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$3,883.74',
//   },
//   {
//     id: '13FXL723253011',
//     desc: 'AGM FoxBat-LE7 3NL1 - Night Vision Bi-Ocular 7.4x Gen 3 "Green Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$5,143.53',
//   },
//   {
//     id: '13FXL723253111',
//     desc: 'AGM FoxBat-LE7 3NL1 - Night Vision Bi-Ocular 7.4x Gen 3 Autogated "White Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator',
//     price: '$5,644.00',
//   },
//   {
//     id: '13FXL923253011',
//     desc: 'AGM FoxBat-LE10 3NL1 - Night Vision Bi-Ocular 9.6x Gen 3 "Green Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator. Made in USA!',
//     price: '$7,348.53',
//   },
//   {
//     id: '13FXL923253111',
//     desc: 'AGM FoxBat-LE10 3NL1 - Night Vision Bi-Ocular 9.6x Gen 3 "White Phosphor" "Level 1" with Sioux850 Long-Range Infrared Illuminator. Made in USA!',
//     price: '$7,989.00',
//   },
//   {
//     id: '6606TTR1',
//     desc: 'Professional Titanium Tripod with a Grip',
//     price: '$261.03',
//   },
//   {
//     id: '6610HCS1',
//     desc: 'Hard Case for Storage/Transportation for FoxBat5',
//     price: '$98.49',
//   },
//   {
//     id: '6610HC71',
//     desc: 'Hard Case for Storage/Transportation for FoxBat LE6/7',
//     price: '$261.03',
//   },
//   {
//     id: '15WP4422453011',
//     desc: 'AGM Wolverine Pro-4 NL1 - Night Vision Rifle Scope 4x Gen 2+ "Green Phosphor" "Level 1"',
//     price: '$3,879.33',
//   },
//   {
//     id: '15WP4423453111',
//     desc: 'AGM Wolverine Pro-4 3AL1 - Night Vision Rifle Scope 4x Gen 3 Auto-Gated "Green Phosphor" "Level 1"',
//     price: '$4,720.07',
//   },
//   {
//     id: '15WP4423454111',
//     desc: 'AGM Wolverine Pro-4 3AW1 - Night Vision Rifle Scope 4x Gen 3 Auto-Gated "White Phosphor Level 1"',
//     price: '$4,930.00',
//   },
//   {
//     id: '15WP6622453011',
//     desc: 'AGM Wolverine Pro-6 NL1 - Night Vision Rifle Scope 6x Gen 2+ "Green Phosphor" "Level 1"',
//     price: '$4,194.75',
//   },
//   {
//     id: '15WP6623453111',
//     desc: 'AGM Wolverine Pro-6 3AL1 - Night Vision Rifle Scope 6x Gen 3 Auto-Gated "Green Phosphor" "Level 1"',
//     price: '$5,034.96',
//   },
//   {
//     id: '15WP6623454111',
//     desc: 'AGM Wolverine Pro-6 3AW1 - Night Vision Rifle Scope 6x Gen 3 Auto-Gated "White Phosphor" "Level 1"',
//     price: '$5,244.75',
//   },
//   {
//     id: '16CO2122103021',
//     desc: 'AGM Comanche-22 NL2 - Medium Range Night Vision Clip-On System Gen 2+ "Green Phosphor" "Level 2"',
//     price: '$2,096.85',
//   },
//   {
//     id: '16CO2122104021',
//     desc: 'AGM Comanche-22 NW2 - Medium Range Night Vision Clip-On System Gen 2+ "White Phosphor Level 2"',
//     price: '$2,203.53',
//   },
//   {
//     id: '16CO2123253011',
//     desc: 'AGM Comanche-22 3NL1 - Medium Range Night Vision Clip-On System Gen 3 "Green Phosphor" "Level 1"',
//     price: '$4,196.85',
//   },
//   {
//     id: '16CO4122453011',
//     desc: 'AGM Comanche-40 NL1 - Night Vision Clip-On System Gen 2+ "Green Phosphor" "Level 1"',
//     price: '$2,938.53',
//   },
//   {
//     id: '16CO4123453111',
//     desc: 'AGM Comanche-40 3AL1 - Night Vision Clip-On System Gen 3+ Auto-Gated "Green Phosphor" "Level 1"',
//     price: '$3,988.53',
//   },
//   {
//     id: '16CO4123454111',
//     desc: 'AGM Comanche-40 3AW1 - Night Vision Clip-On System Gen 3+ Auto-Gated "White Phosphor Level 1"',
//     price: '$4,199.37',
//   },
//   {
//     id: '6606SM11',
//     desc: 'AGM Front Scope Mount #1 for Daytime Optics with 25.4-30 mm Objective Diameter (works with Comanche 22, Victrix, Anaconda)',
//     price: '$102.48',
//   },
//   {
//     id: '6606SM21',
//     desc: 'AGM Front Scope Mount #2 for Daytime Optics with 38-42 mm Objective Diameter (works with Comanche 22, Victrix, Anaconda)',
//     price: '$102.48',
//   },
//   {
//     id: '6606SM31',
//     desc: 'AGM Front Scope Mount #3 for Daytime Optics with 46.7-50 mm Objective Diameter (works with Comanche 22, Victrix, Anaconda)',
//     price: '$102.48',
//   },
//   {
//     id: '6606SM41',
//     desc: 'AGM Front Scope Mount #4 for Daytime Optics with 56-58.7 mm Objective Diameter (works with Comanche 22, Victrix, Anaconda)',
//     price: '$102.48',
//   },
//   {
//     id: '6606SM51',
//     desc: 'AGM Front Scope Mount #5 for Daytime Optics with 62 mm Objective Diameter (works with Comanche 22, Victrix, Anaconda)',
//     price: '102.48',
//   },
//   {
//     id: '6605C221',
//     desc: 'AGM CO22-IR Kit - Kit includes: Sioux850 Long-Range Infrared Illuminator, Rechargeable Battery, Charger, Platform Ring, and Picatiny Rail Mount',
//     price: '$248.43',
//   },
//   {
//     id: '6605C401',
//     desc: 'AGM CO40-IR Kit - Kit includes: Sioux850 Long-Range Infrared Illuminator, Rechargeable Battery, Charger, and Platform Ring',
//     price: '$241.08',
//   },
//   {
//     id: '3083451004PR21',
//     desc: 'AGM Protector TM25-384 - Short/Medium Range Thermal Imaging Monocular 384x288 (50 Hz), 25 mm lens',
//     price: '$2,515.01',
//   },
//   {
//     id: '3093451006AS51',
//     desc: 'AGM Asp TM50-336 - Medium Range Thermal Imaging Monocular TAU-2 336x256 (60 Hz), 50 mm lens',
//     price: '$4,482.45',
//   },
//   {
//     id: '3093451008AS71',
//     desc: 'AGM Asp TM75-336 - Long Range Thermal Imaging Monocular TAU-2 336x256 (60 Hz), 75 mm lens',
//     price: '$5,228.11',
//   },
//   {
//     id: '3093551004AS21',
//     desc: 'AGM Asp TM25-640 - Short/Medium Range Thermal Imaging Monocular TAU-2 640x512 (30 Hz), 25 mm lens. Made in USA!',
//     price: '$4,816.18',
//   },
//   {
//     id: '3093551006AS51',
//     desc: 'AGM Asp TM50-640 - Medium Range Thermal Imaging Monocular TAU-2 640x512 (30 Hz), 50 mm lens',
//     price: '$5,760.83',
//   },
//   {
//     id: '3093551008AS71',
//     desc: 'AGM Asp TM75-640 - Long Range Thermal Imaging Monocular TAU-2 640x512 (30 Hz), 75 mm lens',
//     price: '$6,592.95',
//   },
//   {
//     id: '3093453006CO51',
//     desc: 'AGM Cobra TB50-336 - Medium Range Thermal Imaging Bi-Ocular TAU-2 336x256 (60 Hz), 50 mm lens',
//     price: '$4,931.57',
//   },
//   {
//     id: '3093453008CO71',
//     desc: 'AGM Cobra TB75-336 - Long Range Thermal Imaging Bi-Ocular TAU-2 336x256 (60 Hz), 75 mm lens',
//     price: '$5,984.37',
//   },
//   {
//     id: '3093553006CO51',
//     desc: 'AGM Cobra TB50-640 - Medium Range Thermal Imaging Bi-Ocular TAU-2 640x512 (30 Hz), 50 mm lens',
//     price: '$6,296.54',
//   },
//   {
//     id: '3093553008CO71',
//     desc: 'AGM Cobra TB75-640 - Long Range Thermal Imaging Bi-Ocular TAU-2 640x512 (30 Hz), 75 mm lens',
//     price: '$7,347.06',
//   },
//   {
//     id: '3093455004PY21',
//     desc: 'AGM Python TS25-336 - Short/Medium Range Thermal Imaging Rifle Scope TAU-2 336x256 (60 Hz), 25 mm lens',
//     price: '$3,461.85',
//   },
//   {
//     id: '3093455006PY51',
//     desc: 'AGM Python TS50-336 - Medium Range Thermal Imaging Rifle Scope TAU-2 336x256 (60 Hz), 50 mm lens',
//     price: '$4,490.45',
//   },
//   {
//     id: '3093455008PY71',
//     desc: 'AGM Python TS75-336 - Long Range Thermal Imaging Rifle Scope TAU-2 336x256 (60 Hz), 75 mm lens',
//     price: '$5,246.90',
//   },
//   {
//     id: '3093555004PY21',
//     desc: 'AGM Python TS25-640 - Short Range Thermal Imaging Rifle Scope TAU-2 640x512 (30 Hz), 25 mm lens',
//     price: '$4,825.22',
//   },
//   {
//     id: '3093555006PY51',
//     desc: 'AGM Python TS50-640 - Medium Range Thermal Imaging Rifle Scope TAU-2 640x512 (30 Hz), 50 mm lens',
//     price: '$5,769.25',
//   },
//   {
//     id: '3093555008PY71',
//     desc: 'AGM Python TS75-640 - Long Range Thermal Imaging Rifle Scope TAU-2 640x512 (30 Hz), 75 mm lens',
//     price: '$6,611.54',
//   },
//   {
//     id: '3093556006AN51',
//     desc: 'AGM Anaconda TC50-640 - Medium Range Thermal Imaging Clip-On TAU-2 640x512 (30 Hz), 50 mm lens',
//     price: '$5,772.11',
//   },
//   {
//     id: '6305WIF1',
//     desc: 'AGM WiFi Attachment (works with Python 336/640)',
//     price: '$204.75',
//   },
//   {
//     id: '6305HDR1',
//     desc: 'AGM HD Recorder (works with Python 336/640)',
//     price: '$236.25',
//   },
//   {
//     id: '6308EXB1',
//     desc: 'AGM Extended Battery Pack (works with Python 336/640)',
//     price: '$204.75',
//   },
//   {
//     id: '503RMSALAGMDE1',
//     desc: 'RMSAL Rifle Mounted Squad Aiming Laser with VIS/IR aiming and IR Illuminating lasers. Visible laser is 520nm GREEN. Class IIIb',
//     price: '$1,403.85',
//   },
//   {
//     id: '503TMAIMAGMDE1',
//     desc: 'T-MAIM Tactical Multispectral Aiming/Illum Module with VIS/IR aiming and IR Illuminating lasers. Visible laser is 635nm RED. CLASS IIIb',
//     price: '$1,325.00',
//   },
//   {
//     id: 'V-MANTIS-BK-L2',
//     desc: 'Mantis Concealable Vest, level II Low-Cost Soft armor, Black',
//     price: '$448.00',
//   },
//   {
//     id: 'V-MANTIS-BK-L3A',
//     desc: 'Mantis Concealable Vest, level IIIA Low-Cost Soft armor, Black',
//     price: '$470.00',
//   },
//   {
//     id: 'V-MANTIS-BK-F2',
//     desc: 'Mantis Concealable Vest, NIJ Fusion level II Soft armor, Black',
//     price: '$528.00',
//   },
//   {
//     id: 'V-MANTIS-BK-F3A',
//     desc: 'Mantis Concealable Vest, NIJ Fusion level IIIA Soft armor, Black',
//     price: '$550.00',
//   },
//   {
//     id: 'V-MANTIS-BK-H2',
//     desc: 'Mantis Concealable Vest, High-End level II Soft armor, Black',
//     price: '$768.00',
//   },
//   {
//     id: 'V-MANTIS-BK-H3A',
//     desc: 'Mantis Concealable Vest, High-End level IIIA Soft armor, Black',
//     price: '$790.00',
//   },
//   {
//     id: 'V-INTAC-BK-L2',
//     desc: 'InTac Basic Tactical Vest, level II Low-Cost Soft armor, Black',
//     price: '$588.00',
//   },
//   {
//     id: 'V-INTAC-BK-L3A',
//     desc: 'InTac Basic Tactical Vest, level IIIA Low-Cost Soft armor, Black',
//     price: '$650.00',
//   },
//   {
//     id: 'V-INTAC-BK-F2',
//     desc: 'InTac Basic Tactical Vest, NIJ level II Soft armor, Black',
//     price: '$668.00',
//   },
//   {
//     id: 'V-INTAC-BK-F3A',
//     desc: 'InTac Basic Tactical Vest, NIJ Fusion level IIIA Soft armor, Black',
//     price: '$730.00',
//   },
//   {
//     id: 'V-INTAC-BK-H2',
//     desc: 'InTac Basic Tactical Vest, level II High-End Soft armor, Black',
//     price: '$988.00',
//   },
//   {
//     id: 'V-INTAC-BK-H3A',
//     desc: 'InTac Basic Tactical Vest, level IIIA High-End Soft armor, Black',
//     price: '$1,070.00',
//   },
//   {
//     id: 'V-FRPC-COY-L3A',
//     desc: 'FRPC Basic Plate Carrier, w/level IIIA Low-Cost Soft armor (front/back/sides), Coyote',
//     price: '$790.00',
//   },
//   {
//     id: 'V-FRPC-COY-F3A',
//     desc: 'FRPC Basic Plate Carrier, w/NIJ Fusion level IIIA Soft armor (front/back/sides), Coyote',
//     price: '$910.00',
//   },
//   {
//     id: 'V-FRPC-COY-H3A',
//     desc: 'FRPC Basic Plate Carrier, w/level IIIA High-End Soft armor (front/back/sides), Coyote',
//     price: '$1,250.00',
//   },
//   {
//     id: 'V-FRPC-COY-OS',
//     desc: 'FRPC Basic Plate Carrier, w/o soft armor, CARRIER OUTER SHELL ONLY, Coyote (armor NOT included)',
//     price: '$330.00',
//   },
//   {
//     id: 'V-MCPC-BK-L3A',
//     desc: 'MCPC Modular Commercial Plate Carrier (Scalable), w/level IIIA Low-Cost Soft armor (front/back/sides), Black',
//     price: '$930.00',
//   },
//   {
//     id: 'V-MCPC-BK-F3A',
//     desc: 'MCPC Modular Commercial Plate Carrier (Scalable), w/NIJ Fusion level IIIA Soft armor (front/back/sides), Black',
//     price: '$1,050.00',
//   },
//   {
//     id: 'V-MCPC-BK-H3A',
//     desc: 'MCPC Modular Commercial Plate Carrier (Scalable), w/level IIIA High-End Soft armor (front/back/sides), Black',
//     price: '$1,370.00',
//   },
//   {
//     id: 'V-MCPC-BK-OS',
//     desc: 'MCPC Modular Commercial Plate Carrier, w/o soft armor, CARRIER OUTER SHELL ONLY, Black (armor NOT included)',
//     price: '$470.00',
//   },
//   {
//     id: 'BP-AFC3CE-1012-MC',
//     desc: 'Ballistic Plate, Level III+, NIJ 0101.06 Certified Plate, Stand-alone, 10x12, Shooters Cut, Multi-Curve, Model AFC-RF2-3CE',
//     price: '$470.00',
//   },
//   {
//     id: 'BP-AFC3CE-810-MC',
//     desc: 'Ballistic Plate, Level III+, NIJ 0101.06 Certified Plate, Stand-alone, 8x10, Shooters Cut, Multi-Curve, Model AFC-RF2-3CE',
//     price: '$450.00',
//   },
//   {
//     id: 'SAI-1012-F3A',
//     desc: 'Soft Armor Insert, NIJ Fusion Level IIIA, 10"x12" Plate Backer (Shooters Cut, per piece)',
//     price: '$164.00',
//   },
//   {
//     id: 'SAI-ESAPI-XS-F3A',
//     desc: 'Soft Armor Insert, NIJ Fusion Level IIIA, SAPI/ESAPI Size XS Plate Backer (per piece)',
//     price: '$106.00',
//   },
//   {
//     id: 'SAI-ESAPI-SM-F3A',
//     desc: 'Soft Armor Insert, NIJ Fusion Level IIIA, SAPI/ESAPI Size SM Plate Backer (per piece)',
//     price: '$110.00',
//   },
//   {
//     id: 'SAI-ESAPI-MD-F3A',
//     desc: 'Soft Armor Insert, NIJ Level Fusion IIIA, SAPI/ESAPI Size MD Plate Backer (per piece)',
//     price: '$148.00',
//   },
//   {
//     id: 'SAI-ESAPI-LG-F3A',
//     desc: 'Soft Armor Insert, NIJ Fusion Level IIIA, SAPI/ESAPI Size LG Plate Backer (per piece)',
//     price: '$170.00',
//   },
//   {
//     id: 'SAI-ESAPI-XL-F3A',
//     desc: 'Soft Armor Insert, NIJ Fusion Level IIIA, SAPI/ESAPI Size XL Plate Backer (per piece)',
//     price: '$186.00',
//   },
//   {
//     id: 'SAI-SPEAR-F3A',
//     desc: 'Soft Armor Inserts, NIJ Fusion Level IIIA, SPEAR/BALCS Shape and Grade (per set front & back)',
//     price: '$710.00',
//   },
// ];

const catalog = [
  {
    id: 'I518VC1-S',
    desc: 'INDUSTRIAL 5HP 1PH 80GAL. HORIZ. W/MAG MOUNTED',
    manu: 'Castair',
    price: '$4,634.00',
  },
  {
    id: 'I718VC1-S',
    desc: 'INDUSTRIAL 7.5HP 1PH 120GAL. HORIZ. 2-STAGE 2-CYL W/MAG MTD & WIRED',
    manu: 'Castair',
    price: '$5,113.00',
  },
  {
    id: 'I718VC2-S',
    desc: '7.5HP 1PH 585 RPM PUMP 80GAL. VERT. W/MAG',
    manu: 'Castair',
    price: '$6,010.00',
  },
  {
    id: 'I1018VC2-S',
    desc: '10HP 1PH 80GAL VERT. W/MAG.',
    manu: 'Castair',
    price: '$7,454.00',
  },
  {
    id: 'I538VC1-S',
    desc: '5HP 3PH 80GAL. VERT. W/MAG',
    manu: 'Castair',
    price: '$4,708.00',
  },
  {
    id: 'I738VC1-S',
    desc: '7.5HP 3PH 80GAL. VERT. W/MAG',
    manu: 'Castair',
    price: '$5,025.00',
  },
  {
    id: 'I1038VC2-S',
    desc: '10HP 3PH 80 GAL VERT. W/MAG',
    manu: 'Castair',
    price: '$6,332.00',
  },
  {
    id: 'I7312VC2-S',
    desc: '7.5HP 3PH 120GAL. VERT. W/MAG',
    manu: 'Castair',
    price: '$7,601.00',
  },
  {
    id: 'I10312VC2-S',
    desc: '10HP 3PH 120 GAL VERT. W/MAG',
    manu: 'Castair',
    price: '$8,019.00',
  },
  {
    id: 'I518HC1-S',
    desc: '5HP 1PH 80GAL. HORIZ. W/MAG',
    manu: 'Castair',
    price: '$5,166.00',
  },
  {
    id: 'I718HC1-S',
    desc: '7.5HP 1PH 80GAL. HORIZ. W/MAG',
    manu: 'Castair',
    price: '$5,649.00',
  },
  {
    id: 'I7112HC2-S',
    desc: '7.5HP 1PH 120GAL. HORIZ. W/MAG',
    manu: 'Castair',
    price: '$6,939.00',
  },
  {
    id: 'I538HC1-S',
    desc: '5HP 3PH 80GAL. HORIZ. W/MAG',
    manu: 'Castair',
    price: '$5,245.00',
  },
  {
    id: 'I738HC1-S',
    desc: '7.5HP 3PH 80GAL. HORIZ. W/MAG',
    manu: 'Castair',
    price: '$5,561.00',
  },
  {
    id: 'GA5W30',
    desc: 'GALLON OF 5W30 WEIGHT SEMI-SYN PISTON / RECIP. AIR COMP OIL. 6 PER CASE',
    manu: 'Castair',
    price: '$300.00',
  },
  {
    id: 'QT5W30',
    desc: 'QUART OF 5W30 WEIGHT SEMI-SYN PISTON / RECIP. AIR COMP OIL. 12 PER CASE',
    manu: 'Castair',
    price: '$180.00',
  },
  {
    id: 'GA10W30',
    desc: '1-GALLON 10W30 WEIGHT FULL SYNTHETIC CAST-LUBE PISTON OIL. 6 PER CASE',
    manu: 'Castair',
    price: '$498.00',
  },
  {
    id: 'QT10W30',
    desc: 'QUART 10W30 WEIGHT SYNTHETIC CAST-LUBE PISTON. 12 PER CASE',
    manu: 'Castair',
    price: '$396.00',
  },
];

const tableBody = document.querySelector('.table__catalog tbody');

catalog.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
